import { Module } from "vuex";

export const DispatchManagement: Module<any, any> = {
  state: {
    formDispatch: {},
  },
  getters: {
    formDispatch: (state) => state.query,
  },
  mutations: {
    setformDispatch(state, data) {
      state.formDispatch = data;
    },
  },
  actions: {
    setformDispatch(query) {
      query.commit("setformDispatch");
    },
  },
};
